import React from "react";
import "../Pagination/Pagination.scss";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { AiOutlineDoubleLeft } from "react-icons/ai";
import { useSelector } from "react-redux";
import { PAGE_SIZE } from "../../../utils/constants";

//How many page numbers are visible at a time
const PAGE_WINDOW = 10

const Pagination = (props: any) => {
  const { layouts } = useSelector((s: any) => s.lmsStore);

  //pageNumber is zero based, same as the API
  const { pageNumber = 0, onPageChange } = props

  const totalCount = layouts?.totalCount || 0
  const pageSize = layouts?.pageSize || PAGE_SIZE
  const totalPage = layouts?.totalPage || 0

  if (!totalCount || !totalPage) return null

  //Window of page numbers around the current page
  const windowIndex = Math.floor(pageNumber / PAGE_WINDOW)
  const firstPage = windowIndex * PAGE_WINDOW
  const lastPage = Math.min(firstPage + PAGE_WINDOW, totalPage)
  const pages = Array.from({ length: lastPage - firstPage }, (_, i) => firstPage + i)

  const lowerBound = (pageNumber * pageSize) + 1
  const upperBound = Math.min((pageNumber + 1) * pageSize, totalCount)

  const currentPageHandler = (_pageNumber: number) => {
    if (_pageNumber < 0 || _pageNumber > totalPage - 1 || _pageNumber == pageNumber) return
    onPageChange && onPageChange(_pageNumber)
  }

  //Jump to the previous / next window of page numbers
  const leftClickNavigationHandler = () => {
    currentPageHandler(Math.max(firstPage - PAGE_WINDOW, 0))
  }

  const rightClickNavigationHandler = () => {
    if (lastPage > totalPage - 1) return
    currentPageHandler(lastPage)
  }

  return (
    <>
      <div className="pagelist-pagination p-[15px] fixed bg-sky-50">
        <div className="pagination-inner flex justify-between items-center">
          <p className="display-txt">Displaying {`${lowerBound} - ${upperBound}`} of {totalCount} results.</p>
          <div className="pagination-list flex">
            <div className={`page-number ${firstPage == 0 ? "disabled" : ""}`}>
              <p>
                <AiOutlineDoubleLeft onClick={leftClickNavigationHandler} />
              </p>
            </div>
            {pages.map((d: number) =>
              <div onClick={() => currentPageHandler(d)} key={d} className={`${(d == pageNumber) && "active"} page-number`} >
                <p>{d + 1}</p>
              </div>
            )}
            <div className={`page-number ${lastPage > totalPage - 1 ? "disabled" : ""}`}>
              <p>
                <AiOutlineDoubleRight onClick={rightClickNavigationHandler} />
              </p>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default Pagination;
